import type { QuoteSources } from './types';

/**
 * Quote id shared by every insurer of this quote. Quálitas can fail while ANA answers,
 * so its response is not the only place to read it from.
 */
export const resolveIdCotizacion = (sources: QuoteSources): number | undefined =>
  sources.quotesResponse.value?.Cobertura?.Id_Cotizacion
  || sources.quoteData.cotizacionData?.idCotizacion
  || sources.anaQuotes.value?.Cobertura?.Id_Cotizacion
  || undefined;
